import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const GoalsOverviewLink = ({
  onClickAttainmentBar
}) =>
/*#__PURE__*/
// TODO: replace with `Button` from foundations-components when the link styling is ready
// https://git.hubteam.com/HubSpot/forecasting-team/issues/2409
_jsx(UILink, {
  onClick: () => onClickAttainmentBar(),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'repOverviewTable.attainmentCell.tooltip.seeGoalsOverview'
  })
});
export default GoalsOverviewLink;